export default __webpack_public_path__ + "static/media/banner2.12958049.png";